module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "velkommen topspacing"
  }, [(_vm.showLoader) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "counter"
  }, [(_vm.errorMessage.length == 0) ? _c('div', [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Trin " + _vm._s(_vm.activeStep) + " af " + _vm._s(_vm.totalSteps))])]) : _vm._e(), _vm._v(" "), (_vm.errorMessage.length > 0) ? _c('div', [_vm._v("\n                    " + _vm._s(_vm.errorMessage) + "\n                    "), _c('a', {
    staticClass: "button error-button",
    on: {
      "click": _vm.closeError
    }
  }, [_vm._v("Okay")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid-x grid-padding-x"
  }, [_c('div', {
    staticClass: "large-12 cell"
  }, [_c('section', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content text-center"
  }, [_c('p', [_vm._v("\n                            NIRAS har udviklet et system, der rationaliserer arbejdsopgaver vedrørende kontrol og udskiftning af forbrugsmålere i forsyningssektoren. Programmet hedder MålerTjek, og med det fjerner du tidsrøvere og gør samtidig livet lettere for både forsyningernes montører og deres administration samt for borgerne. \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center download-container"
  }, [_c('a', {
    staticClass: "button call-to-action",
    on: {
      "click": _vm.getServerData
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")]), _vm._v("Hent app")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Installerer MålerTjek app'en "), _c('span', {
    staticClass: "loading-overview"
  }, [_c('span', [_vm._v(".")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v(".")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    staticStyle: {
      "height": "55.4px"
    }
  }, [_c('h1', [_vm._v("Hent indstillinger")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-welcome"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/image/logo.png"),
      "alt": "logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12471b78","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/velkommen.vue
// module id = 1006
// module chunks = 1